<template>
    <div>
        <div v-if="totalCart">
            <div class="main-title">
                <h2>{{ getTranslation('order-content', 'order_cart_info_page_title') }}</h2>

                <div class="order-summary__body mt-5">
                    <!-- new licenses-->
                    <template v-for="product in products" v-if="totalPrice[product.id] || hasSubscriptionCustomization(product.id)">

                        <!-- cloud time licenses-->
                        <div v-if="hasLicenses(getQtyName('lease', 'cloud'), product.id)">
                            <cart-info-licences v-bind:product="product" v-bind:licenceType="getQtyName('lease', 'cloud')" translate="cloud_time_licences_product"></cart-info-licences>
                        </div>

                        <div v-if="totalPerpetualUpgrade[product.id]">
                            <cart-info-perpetual-upgrade v-bind:product="product"></cart-info-perpetual-upgrade>
                        </div>

                        <template v-if="hasSubscriptionCustomization(product.id)">
                            <cart-info-subscription-customization v-bind:product="product" v-bind:licenceType="getQtyName('lease', 'cloud')" translate="cloud_time_licences_product"></cart-info-subscription-customization>
                        </template>

                    </template>


                    <!--lease prolong-->
                    <template v-if="hasLeaseProlong()">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <h3 class="order-summary__head">{{ getTranslation('cart-vue', 'lease_prolongation') }}</h3>
                            </div>
                        </div>

                        <div class="custom-table">
                            <div class="row no-gutters custom-table__body" v-for="product in products" v-if="leaseProlongPrice[product.id]">
                                <div class="col-9">
                                    <div class="custom-table__body--elem">
                                        {{ product.title }}
                                        {{ getTranslation('cart-vue', 'lease_prolongation') }}
                                    </div>
                                </div>
                                <div class="col-3 text-right">
                                    <div class="custom-table__body--elem">
                                        {{ priceFormat(leaseProlongPrice[product.id], false, true) }}
                                    </div>
                                </div>
                                <div class="col-12 d-sm-none custom-table__separator"></div>
                            </div>
                        </div>
                        <br><br>
                    </template>

                    <!--promo subscription-->
                    <template v-if="hasSubscriptionPromo()">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <h3 class="order-summary__head">
                                    {{ getTranslation('promo2025', 'subscription_promo_cart_summary_title', {product_name: leaseProductName()}) }}
                                </h3>
                            </div>
                        </div>
                        <div class="custom-table">
                            <div class="row no-gutters custom-table__body">
                                <div class="col-9">
                                    <div class="custom-table__body--elem">
                                        <ul>
                                            <li v-for="item in promoProgramsInfo()">x{{ item.qty }} {{ item.name }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-3 text-right">
                                    {{ priceFormat(0, true, true) }}
                                </div>
                                <div class="col-12 d-sm-none custom-table__separator"></div>
                            </div>
                        </div>
                        <br><br>
                    </template>

                    <!--delivery-->
                    <template v-if="$store.state.cart.hasDelivery">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <h3 class="order-summary__head">{{ getTranslation('cart-vue', 'delivery') }}</h3>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-9 custom-table__body--elem">{{ getTranslation('front', 'invoice_worldwide_delivery') }}</div>
                            <div class="col-3 text-right custom-table__body--elem">{{ priceFormat(delivery, true) }}</div>
                        </div>

                        <br><br>
                    </template>

                    <!--discounts-->
                    <template v-if="hasDiscounts()">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <h3 class="order-summary__head">{{ getTranslation('user-info', 'discounts') }}</h3>
                            </div>

                        </div>
                        <div class="row no-gutters" v-for="product in products" v-if="volumeDiscount[product.id]">
                            <div class="col-9">
                                    <span class="d-block custom-table__body--elem">
                                        {{ getTranslation('order-content', 'volume_discount_product', {'name': product.name})  }}
                                    </span>
                            </div>

                            <div class="col-3 text-right"><span class="d-block custom-table__body--elem"> - {{ priceFormat(volumeDiscount[product.id]) }}</span></div>
                        </div>
                        <div class="row no-gutters" v-for="product in products" v-if="maintenanceDiscount[product.id]">
                            <div class="col-9">
                                    <span class="d-block custom-table__body--elem">
                                        {{ getTranslation('order-content', 'maintenance_discount_product', {'name': product.name})  }}
                                    </span>
                            </div>

                            <div class="col-3 text-right"><span class="d-block custom-table__body--elem"> - {{ priceFormat(maintenanceDiscount[product.id]) }}</span></div>
                        </div>
                        <br><br>
                    </template>

                    <div class="grand-total" v-if="totalCart">
                        <template v-if="orderHasVat()">
                            <div class="rounding">
                                <div class="row no-gutters">
                                    <div class="col-6 col-sm-6"><div class="rounding__elem"><small>{{ getTranslation('front', 'total')}}:</small></div></div>
                                    <div class="col-6 col-sm-6 text-right"><div class="rounding__elem">{{ priceFormat(totalCart, true, true) }}</div></div>
                                </div>
                            </div>
                            <div class="rounding">
                                <div class="row no-gutters">
                                    <div class="col-6 "><div class="rounding__elem"><small>{{ getTranslation('front', 'VAT') }}:</small></div></div>
                                    <div class="col-6 text-right"><div class="rounding__elem">{{ priceFormat(getVatPrice(), true, true) }}</div></div>
                                </div>
                            </div>
                        </template>

                        <template v-if="orderHasRounding()">
                            <template v-if="!orderHasVat()">
                                <div class="rounding">
                                    <div class="row no-gutters">
                                        <div class="col-6 col-sm-6"><div class="rounding__elem"><small>{{ getTranslation('front', 'total')}}:</small></div></div>
                                        <div class="col-6 col-sm-6 text-right"><div class="rounding__elem">{{ priceFormat(totalCart, true, true) }}</div></div>
                                    </div>
                                </div>
                            </template>
                            <div class="rounding">
                                <div class="row no-gutters">
                                    <div class="col-6 "><div class="rounding__elem"><small>{{ getTranslation('front', 'INVOICE_ROUNDING') }}:</small></div></div>
                                    <div class="col-6 text-right"><div class="rounding__elem">
                                        {{ getRoundingSign() }}
                                        {{ priceFormat(getRoundingPrice(), true, true) }}
                                    </div></div>
                                </div>
                            </div>
                        </template>


                        <div class="row no-gutters">
                            <div class="col-6">
                                <h4>{{ getTranslation('user-info', 'grand_total') }}</h4>
                            </div>
                            <div class="col-6 text-right"><h4>{{ priceFormat(getGrandTotal(), true, true) }}</h4></div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
        <div v-if="!totalCart">
            <div class="order-summary__empty">
                <div class="order-summary__empty--icon">
                    <img :src="imgPath + 'images/shop_icon.svg'" alt="">
                </div>
                <div class="order-summary__empty--msg">
                    {{ getTranslation('order-content', 'cart_empty') }}
                </div>
                <div class="order-summary__empty--hint" v-html="getTranslation('order-content', 'cart_empty_message')">
                </div>
                <a :href="navigation.home" class="btn btn-order">
                    {{ getTranslation('order-content', 'return_to_shop')}}
                </a>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        methods: {
            hasCustomization(id) {
                let items = _.filter(this.$store.state.cart.leaseProlong[id]['info'], function(l) {
                    return (l.days !== false && l.selected === 1 );
                });
                return !_.isEmpty(items);
            },
            hasSubscriptionPromo() {
                if (_.isNil(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                return true;
            },
            leaseProductName() {
                let self = this;
                let name = 'GEO5';
                _.forEach(this.products, function (p, key) {
                    if (p.id == self.$store.state.cart.subscriptionPromo.product) {
                        name = p.name;
                    }
                });
                return name;
            },
            promoProgramsInfo() {
                return this.$store.state.cart.subscriptionPromo.info;
            },
            getProgramLanguages(product, language) {
                if (_.isNil(this.$store.state.cart.programLanguages)) {
                    return;
                }
                let self = this;
                let programList = [];
                _.forOwn(this.$store.state.cart.programLanguages, function(p) {
                    if (p.product == product && p['languages'][language]['status'] == true && p['languages'][language]['existing'] == false) {
                        p.sortOrder = self.getProgramOrder(p.id, p.product);
                        programList.push(self.getProgramName(p.id, product))
                    }

                });
                if (programList.length) {
                    programList = _.sortBy(programList, [function(o) { return o.sortOrder; }]).reverse();
                    return _(programList).forEach(function(num) {  }).join(', ');
                }
                return '';
            },
            hasMaintenance() {
                let self = this;
                let hasM = false;
                _.forOwn(this.products, function(p) {
                    if (self.totalMaintenance[p.id]) {
                        hasM = true;
                    }
                });
                return hasM;
            },
            hasDiscounts() {
                return false;
            },
            hasSingleUpgrade() {
                let self = this;
                let hasM = false;
                _.forOwn(this.products, function(p) {
                    if (self.singleUpgradePrice[p.id]) {
                        hasM = true;
                    }
                });
                return hasM;
            },
            hasLeaseProlong() {
                let self = this;
                let hasM = false;
                _.forOwn(this.products, function(p) {
                    if (self.leaseProlongPrice[p.id]) {
                        hasM = true;
                    }
                });
                return hasM;
            },
            hasSubscriptionCustomization(id) {
                let filtered = _.filter(this.$store.state.cart.leaseProlongConfigs, function(l) { return (l.product === id); });
                return !_.isEmpty(filtered);
            },
            getLanguageName(code, product) {
                let lang = this.languages[product]['items'][code];
                if (_.isNil(lang)) {
                    return 'n/a';
                }
                return lang;
            },
            hasNewLicenses(productId) {
                let hasLicenses = _.find(this.programs, function(l) { return (l.product == productId ); });
                if (!_.isNil(hasLicenses)) {
                    return true;
                }
                return false;
            },
            hasLicenses(type, productId) {
                let hasLicenses = _.find(this.programs, function(l) { return (l.product == productId && l[type] > 0); });
                if (!_.isNil(hasLicenses)) {
                    return true;
                }
                return false;
            },
            calculateTotalLanguages() {
                let self = this;
                let total =  new Object;
                Object.entries(this.products).forEach(([key, pr]) => {
                    total[key] = 0;
                });
                Object.entries(this.programLanguages).forEach(([key, pr]) => {
                    let price = self.getLanguagePrice(pr.id, '', pr.product);

                    Object.entries(pr.languages).forEach(([lang, status]) => {
                        if (status.status == true && status.existing == false) {
                            if (
                                lang != self.$store.state.cart.softwareLanguage[pr.product] &&
                                !_.isNil(self.$store.state.cart.additionalLanguages[pr.product]) &&
                                _.includes(self.$store.state.cart.additionalLanguages[pr.product], lang)
                            ) {
                                total[pr.product] = total[pr.product] + price;
                            }
                        }
                    });
                });
                return total;
            },
            hardlockHasChanges(id) {
                if (this.anyLicencesMoved(id)) {
                    return true;
                }
                let anyMoved = false;
                let hardlock = _.find(this.hardlocks, ['id', id]);
                if (_.isNil(hardlock)) {
                    return anyMoved;
                }
                _.forEach(hardlock.allocated, function(licenceItem) {
                    if (licenceItem.isNew == 1) {
                        anyMoved = true;
                    }
                });
                return anyMoved
            },
            anyLicencesMoved(id = false) {
                return false;
            },
            orderHasVat() {
                if (_.isEmpty(this.$store.state.cart.vatInfo)) {
                    return false;
                }
                return Number(this.$store.state.cart.vatInfo.vatRate) > 0 ?  true : false;
            },
            getVatPrice() {
                if (this.orderHasVat() == false) {
                    return 0;
                }
                return this.totalCart * Number(this.$store.state.cart.vatInfo.vatRate) / 100;
            },
            getGrandTotal() {
                if (this.hasSubscriptionPromo()) {
                    return 0;
                }
                let total = this.orderHasVat() ? (this.totalCart + this.getVatPrice()) : this.totalCart;
                if ((total % 1) >= 0.5) {
                    return Math.ceil(total);
                } else {
                    return Math.floor(total);
                }
            },
            orderHasRounding() {
                let total = this.orderHasVat() ? (this.totalCart + this.getVatPrice()) : this.totalCart;
                return total % 1 != 0;
            },
            getRoundingSign() {
                let total = this.orderHasVat() ? (this.totalCart + this.getVatPrice()) : this.totalCart;
                if ((total % 1) >= 0.5) {
                    return '+';
                }
                return '-';
            },
            getRoundingPrice() {
                let total = this.orderHasVat() ? (this.totalCart + this.getVatPrice()) : this.totalCart;
                if ((total % 1) >= 0.5) {
                    return Math.ceil(total) - total;
                }
                return total - Math.floor(total);
            }
        },
        mounted() {
            this.totalLanguages = this.calculateTotalLanguages();
        },
        computed: {
            delivery() {
                if (_.isNil(this.$store.state.cart.delivery)) {
                    return 0;
                }
                if (this.$store.state.cart.delivery == 0) {
                    return 0;
                }
                return  this.getDeliveryPrice();
            },
            groupedAllocatedLicenceItems() {
                let uniques = {};
                this.hardlocks.forEach(function(element) {
                    uniques[element.id] = [...element.allocated.reduce( (mp, o) => {
                        const key = JSON.stringify([o.time, o.type, o.version, o.id]);
                        if (!mp.has(key)) mp.set(key, { ...o, count: 0 });
                        mp.get(key).count++;
                        return mp;
                    }, new Map).values()];
                });
                return uniques;
            },
            singleUpgradePrice() {
                let self = this;
                let total = {};
                const keys = Object.keys(this.products);

                for (const key of keys) {
                    if (_.isUndefined(total[key])) {
                        total[key] = 0;
                    }
                    if (!_.isUndefined(this.$store.state.cart.singleUpgrade[key]) ) {
                        _.forOwn(this.$store.state.cart.singleUpgrade[key].info, function(pr, ind) {
                            if (pr.selected == true) {
                                let basePrice = self.getProgramPrice(pr.id, '', pr.licence_type, pr.product, pr.quantity);
                                total[key] = total[key] + (basePrice * pr.multiplier/100);
                            }
                        });
                    }

                }

                return total;
            },
            leaseProlongPrice() {
                let self = this;
                let total = {};
                let keys = Object.keys(this.products);

                for (const key of keys) {
                    if (_.isUndefined( total[key])) {
                        total[key] = 0;
                    }
                    if (!_.isUndefined(this.$store.state.cart.leaseProlong[key])) {
                        if (!_.isNil(this.$store.state.cart.leaseProlong[key])) {
                            if (this.$store.state.cart.leaseProlong[key].status) {
                                if (this.isTruss4Product(key)) {
                                    let info = this.$store.state.cart.leaseProlong[key].info[0];
                                    total[key] = this.getTruss4Price(info.id, '', info.licence_type, info.product, this.$store.state.cart.leaseProlong[key].info.length, true)
                                } else {
                                    _.forOwn(this.$store.state.cart.leaseProlong[key].info, function (pr, ind) {
                                        if (pr.selected) {
                                            let basePrice = self.getProgramPrice(pr.id, '', 'cloud_time_quantity', pr.product, pr.quantity, false, pr.discount, pr.days);
                                            total[key] = total[key] + basePrice;
                                        }
                                    });
                                }
                            }
                        }

                    }
                }
                return total;
            },
            totalMaintenance() {
                let total = {};
                let self = this;
                _.forOwn(this.products, function(p) {
                    total[p.id] = self.getProductMaintenancePrice(p.id);
                    if (!_.isNil(self.$store.state.cart.maintenance[p.id]) && self.$store.state.cart.maintenance[p.id].status == false) {
                        total[p.id] = 0;
                    }
                });
                return total;
            },

            maintenanceDiscount() {
                let discount = new Object;
                const keys = Object.keys(this.products);

                for (const key of keys) {
                    if (this.products[key].active_maintenance_discount >0 ) {
                        discount[key] = (Number(this.totalPrice[key]) - Number(this.volumeDiscount[key])) *
                            Number(this.products[key].active_maintenance_discount) / 100;
                        discount[key] = 0;
                    } else {
                        discount[key] = 0;
                    }
                }
                return discount;
            },
            totalPrice() {
                let total = new Object;
                if (this.$store.state.cart.programs.length > 0) {
                    for (let i = 0; i < this.$store.state.cart.programs.length; i++) {
                        let program = this.$store.state.cart.programs[i];

                        if (_.isUndefined(total[program.product])) {
                            total[program.product] = 0;
                        }

                        total[program.product] = (Number(total[program.product]) || 0) +
                            (this.getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.cloud_time_quantity, false, false, program.days) || 0)
                        ;
                    }
                }

                return total;
            },
            volumeDiscount() {
                let countLicences = new Object;
                let priceLicences = new Object;
                let volumeDiscount = new Object;

                for (let product in  this.products) {
                    countLicences[product] = 0;
                    priceLicences[product] = 0;
                    volumeDiscount[product] = 0;
                }
                if (this.$store.state.cart.programs.length > 0) {
                    for (let i = 0; i < this.$store.state.cart.programs.length; i++) {
                        let program = this.$store.state.cart.programs[i];
                        countLicences[program.product] += Number(program.local_quantity) +
                            Number(program.network_quantity);
                        priceLicences[program.product] +=
                            (this.getProgramPrice(program.id, '', 'local_quantity', program.product, program.local_quantity) || 0) +
                            (this.getProgramPrice(program.id, '', 'network_quantity', program.product, program.network_quantity) || 0);
                    }
                }

                for (let product in countLicences) {

                    for (let key in this.volumeDiscountValues[product]) {
                        if (
                            countLicences[product] <= this.volumeDiscountValues[product][key].max &&
                            countLicences[product] >= this.volumeDiscountValues[product][key].min
                        ) {
                            volumeDiscount[product] = priceLicences[product] * this.volumeDiscountValues[product][key].discount / 100;
                        }
                    }
                }

                return volumeDiscount;
            },
            totalHardlocks() {
                let total = 0;
                let currency = window.shopConfigOptions.currency;
                if (this.$store.state.cart.hardlocks.length > 0) {
                    for (let i = 0; i < this.$store.state.cart.hardlocks.length; i++) {
                        let hardlock = this.$store.state.cart.hardlocks[i];
                        if (!_.isUndefined(hardlock.price_list) ) {
                            if (!_.isUndefined(hardlock.price_list[currency]) && hardlock.isNew) {
                                total += Number(hardlock.price_list[currency]);
                            }
                        }
                    }
                }
                return total;
            },

            totalSubscriptionCustomization() {
                let total = {};
                let self = this;
                _.forOwn(this.products, function(p) {
                    total[p.id] = 0;
                });
                _.forOwn(this.$store.state.cart.leaseProlongConfigs, function(l) {
                    total[l.product] += self.getProgramPrice(l.program_id, '', 'cloud_time_quantity', l.product, l.quantity, false, l.discount, l.daysDiff);
                });
                return total;
            },
            totalPerpetualUpgrade() {
                let total = {};
                let self = this;
                _.forOwn(this.products, function(p) {
                    total[p.id] = 0;
                });
                _.forOwn(this.$store.state.cart.programs, function(program) {
                    if (program.perpetual_upgrade) {
                        total[program.product] += self.getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.cloud_time_quantity * 3)
                    }
                });
                return total;
            },

            totalCart() {
                if (this.hasSubscriptionPromo()) {
                    return true;
                }
                let total = 0;
                total += Number(this.totalHardlocks) || 0;
                total += Number(this.delivery) || 0;
                for (let item in this.products) {
                    total += Number(this.totalPrice[item]) || 0;
                    total += Number(this.totalLanguages[item]) || 0;
                    total += Number(this.totalMaintenance[item]) || 0;
                    total += Number(this.singleUpgradePrice[item]) || 0;
                    total += Number(this.leaseProlongPrice[item]) || 0;
                    total += Number(this.totalPerpetualUpgrade[item]) || 0;
                    total += Number(this.totalSubscriptionCustomization[item]) || 0;

                    total -= Number(this.volumeDiscount[item]) || 0;
                    total -= Number(this.maintenanceDiscount[item]) || 0;
                }
                return total;
            },
            programLanguageLength() {
                return _.size(this.programLanguages);
            },
            programsLength() {
                return _.size(this.$store.state.cart.programs);
            },
            sortedCartLanguages() {
                let tmp = new Array();
                let self = this;
                let keys = Object.keys(this.languages);
                for (let i = 0; i < keys.length; i++) {
                    if (!_.isNil(this.$store.state.cart.additionalLanguages[keys[i]])) {
                        this.$store.state.cart.additionalLanguages[keys[i]].forEach(function (lang) {
                            let name = Object.entries(self.languages[keys[i]].items).filter(obj => {
                                return obj[0] == lang;
                            });
                            let price = 0;

                            _.forOwn(self.$store.state.cart.programLanguages, function (pr, key) {
                                if (!_.isNil(pr.languages[lang])) {
                                    if (pr.product == keys[i] && pr.languages[lang].status == true && pr.languages[lang].existing == false) {
                                        price += self.getLanguagePrice(pr.id, '', pr.product)
                                    }
                                }
                            });

                            name[0].push(price);
                            name[0].push(keys[i]);
                            tmp = tmp.concat(name)
                        });
                    }
                }

                return tmp.sort(function (a, b) {
                    return a[1].localeCompare(b[1], self.currentLocale);
                });

            }
        },
        data() {
            return {
                products: window.jsonProducts,
                hardlocks: this.$store.state.cart.hardlocks,
                programs: this.$store.state.cart.programs,
                programLanguages: this.$store.state.cart.programLanguages,
                additionalLanguages: this.$store.state.cart.additionalLanguages,
                cartMaintenance: this.$store.state.cart.maintenance,
                expressDeliveryPrice:  window.expressDeliveryPrice,
                totalLanguages: [],
                volumeDiscountValues:  window.jsonVolumeDiscount,
                navigation: window.quickNavigationUrls,
                imgPath: window.imgPath,
                languages: window.jsonAdditionalLanguages,
            };
        }
    }
</script>
